export default [
  {
    title: 'Gestion des Factures Fournisseur',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Liste des Factures',
        route: 'invoice-list-direx',
        icon: 'ListIcon',
      },
      {
        title: 'Créer une Facture',
        route: 'invoice-create-direx',
        icon: 'PlusCircleIcon',
      },
    ],
  },
]
